import React, {useContext } from "react";
import "../../../ui-styles/cards/Prescription.css";

import { LangCtx } from "../../../lib/context";
import Button from "../../../lib/ui/buttons/Button";
import NoData from "../../../lib/ui/nodata/NoData";

const NewPrescription = (props) => {
    const { l } = useContext(LangCtx);
    const { handleModal, uploadFile } = props;
    
    return <div className="prescriptionCard">
        <div className="presCardBdy noPrescMsg">
            <NoData src="/images/icons/prescription-new.png" label={l.no_presc_desc} />
            <Button
                label={l.add_presc}
                size="sm"
                type="primary"
                onClick={handleModal}
                />
                {console.log("jagjsa")}
            <span>{l.or_op}</span>
            <div className="uploadPrescBtn sm">
                <input type="file" id="file" onChange={uploadFile} accept="application/pdf,image/x-png,image/jpg,image/jpeg,image/png" />
                <label htmlFor="file">{l.upl_presc}</label>
            </div>
            <span className="smallPTxt">{l.upload_presc_note}</span>
        </div>
    </div>

}

export default NewPrescription